import { Component, OnInit, ViewChild } from '@angular/core';
import { MedicineTypeService } from "../../../../services/medicine-type.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from "../../../../services/global.service";
import swal from 'sweetalert2'
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
@Component({
  selector: 'app-setting-medicine-type',
  templateUrl: './setting-medicine-type.component.html',
  styleUrls: ['./setting-medicine-type.component.scss']
})
export class SettingMedicineTypeComponent implements OnInit {
  medicine_types: MatTableDataSource<any>;
  medicinesTypeForm: FormGroup;
  filtersForm: FormGroup;
  submitted = false;

  displayedColumns: string[] = ['index', 'name', 'action']
  @ViewChild(MatSort) sort: MatSort
  @ViewChild(MatPaginator) paginator: MatPaginator
  constructor(
    private MedicineTypeService: MedicineTypeService,
    private formBuilder: FormBuilder,
    private Global: GlobalService
  ) { }

  ngOnInit() {
    this.getMedicineTypes()
    this.setFiltersForm()
    this.setForm()
  }

  setFiltersForm() {
    this.filtersForm = this.formBuilder.group({
      keywords: ''
    });
  }

  setForm() {
    this.medicinesTypeForm = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }

  showForm(medicine_types = null) {
    this.submitted = false;
    if (medicine_types != null) {
      this.medicinesTypeForm = this.formBuilder.group({
        name: [medicine_types.name, Validators.required],
        id: medicine_types['id']
      });
    }
    else {
      this.setForm()
    }
  }

  getMedicineTypes() {
    var filters = {}
    if (this.filtersForm) {
      filters['keywords'] = this.filtersForm.value.keywords
    }

    this.MedicineTypeService.getMedicineTypes(filters).subscribe(data => {
      let medicine_types
      medicine_types = data
      let array = medicine_types.map((item, index) => {
        item.index = index + 1
        return item
      })
      this.medicine_types = new MatTableDataSource(array)
      this.medicine_types.sort = this.sort
      this.medicine_types.paginator = this.paginator
    })
  }

  get f() { return this.medicinesTypeForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.medicinesTypeForm.invalid) {
      return;
    }
    const fd = new FormData();
    swal({
      title: 'ยืนยันการบันทึก',
      text: "คุณต้องการบันทึกข้อมูลใช่หรือไม่ ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36a3f7',
      cancelButtonColor: '#f4516c',
      confirmButtonText: 'ใช่, บันทึกข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        fd.append('medicine_type[name]', this.medicinesTypeForm.controls.name.value)
        var medicine_type_id = ''
        if (this.medicinesTypeForm.controls.id) {
          medicine_type_id = this.medicinesTypeForm.controls.id.value
        }
        this.MedicineTypeService.submitMedicineType(fd, medicine_type_id).subscribe(res => {
          if (res['error']) {
            swal({
              type: 'warning',
              title: 'การบันทึกข้อมูลผิดพลาด',
              showConfirmButton: true,
            })
          }
          else {
            swal({
              type: 'success',
              title: 'บันทึกข้อมูลเรียบร้อยแล้ว',
              showConfirmButton: false,
              timer: 1500
            })
            this.getMedicineTypes();
            this.setForm()
            this.submitted = false
            this.Global.loadScript('assets/script/modal.js');
          }
        })
      }
    })
  }

  delete(id) {
    swal({
      title: 'ยืนยันการลบข้อมูล',
      text: "คุณต้องการลบข้อมูลใช่หรือไม่ ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36a3f7',
      cancelButtonColor: '#f4516c',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.MedicineTypeService.deleteMedicineType(id).subscribe(res => {
          swal({
            type: 'success',
            title: 'ลบข้อมูลเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.getMedicineTypes();
        })
      }
    })
  }
}
